<ng-container *ngIf="productAvailability">
  <ng-container [ngSwitch]="productAvailability.status">
    <ng-container *ngSwitchCase="'LIMITED'">
      <mat-chip-set *ngIf="productAvailability.showDeliveryRegionBadges">
        <mat-chip
          *ngFor="
            let region of productAvailability.variantAvailableRegions;
            trackBy: 'id' | trackBy
          "
          [matTooltip]="language.availabilityNote + region.name + '.'"
          matTooltipPosition="below"
          matTooltipClass="accent p-4"
        >
          {{ region.label }}
        </mat-chip>
      </mat-chip-set>
    </ng-container>

    <div class="next-available-date" *ngSwitchCase="'AVAILABLE'">
      <div class="chip" *ngIf="productAvailability.nextAvailableDate">
        <span class="ellipse">
          <ng-container i18n="@@OrderItem.Available">Available</ng-container>
        </span>
        <span class="no-ellipse">
          {{ productAvailability.nextAvailableDate | date : 'd MMM' }}
        </span>
      </div>
    </div>
  </ng-container>
</ng-container>
